import { AxiosResponse } from 'axios';

import useAPIMutation from '../api/useAPIMutation';
import { InterviewCollectionSerializer } from '../types/api';

interface UseCreateInterviewMutationVariables {
  stageId: number;
  recruitmentProcessId: number;
}

interface UseCreateInterviewMutationProps {
  onSuccess?:
    | ((
        data: AxiosResponse<InterviewCollectionSerializer, unknown>,
        variables: UseCreateInterviewMutationVariables,
        context: unknown
      ) => Promise<unknown> | void)
    | undefined;
}

const useCreateInterviewMutation = ({ onSuccess }: UseCreateInterviewMutationProps) => {
  return useAPIMutation(
    async ({ stageId, recruitmentProcessId }: UseCreateInterviewMutationVariables, api) => {
      return await api.post('/interviews/', {
        stage: stageId,
        recruitment_process: recruitmentProcessId,
      });
    },
    {
      onSuccess,
    }
  );
};

export default useCreateInterviewMutation;
